export { default } from './BackgroundImage';
